import React, { PropTypes } from 'react';

import { byIdShape } from 'utils/propTypes';

import Reviews from '../Reviews';
import Review from '../Review';


const PlaceReviews = ({ reviews, reviewsById, placesById }) => (
  <div>
    { reviews ?
      <Reviews>
        { reviews.map((id) => {
          const review = reviewsById[id];
          const place = placesById[review.place];
          if (place) {
            return (
              <Review
                review={review}
                title={place.name}
                link={`/${place.category}/${place.pk}/`}
                key={id}
              />
            );
          }
          return <li key={id} />;
        }) }
      </Reviews>
    : 'Loading...' }
  </div>
);

PlaceReviews.propTypes = {
  placesById: byIdShape,
  reviews: PropTypes.arrayOf(PropTypes.number),
  reviewsById: byIdShape,
};

PlaceReviews.defaultProps = {
  placesById: {},
  reviews: [],
  reviewsById: {},
};

export default PlaceReviews;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/User/components/PlaceReviews/index.jsx